export enum soeLowStatus {
  ASSIGN = 'assign',
  UNASSIGNED = 'unassigned',
}

export enum soeUppStatus {
  ASSIGN = 'Assign',
  UNASSIGNED = 'Unassigned',
}
